import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { Grid, withTheme } from '@material-ui/core';
import NumericUpDown from './atom/NumericUpDown';
import PriceRuleSelect from './atom/PriceRuleSelect';
import { useModals, MODAL_TYPE } from '../hooks/useModal';
import FormSection from './atom/FormSection';
import { useSwaggerClient } from '../hooks/useSwaggerClient';
import { formatMoney } from '../utils';
import { WarningIcon } from '../icons';

// TODO: move out addon handling from this file
function BookingConfigurationItem({
    guestCount,
    // currently added addons
    itemAddons,
    addAddon,
    theme,
    activity_start,
    activityId
}) {
    const { showModal } = useModals();
    const [allAddons, loading] = useSwaggerClient(
        'activities',
        'getAddonsForActivity',
        {
            activityId,
            activity_start
        },
        []
    );

    // overlay allAddons with itemAddons
    const addons =
        loading || !allAddons || allAddons.length === 0
            ? null
            : allAddons.map(addon => {
                  const alreadyHave = itemAddons.find(e => e.id === addon.id);
                  if (alreadyHave) {
                      return {
                          ...addon,
                          quantity: alreadyHave.quantity
                      };
                  }
                  return { ...addon, quantity: 0 };
              });

    const setAddonQuantity = useCallback(
        (addonId, newQuantity) => {
            const addon = addons.find(e => e.id === addonId);
            if (!addon) {
                return;
            }

            addAddon({ ...addon, quantity: newQuantity });
        },
        [addAddon, addons]
    );

    const addonCount =
        addons === null ? 0 : addons.reduce((count, { quantity }) => count + quantity, 0);
    const [exceedWarning, hideExceedWarning] = useState(true);

    if (addons === null || addons.length === 0 || loading) {
        return null;
    }

    return (
        <FormSection title="Available Add-Ons">
            <Grid item xs={12}>
                <div>
                    For a more complete experience, add-on purchases to your booking are available.{' '}
                    <span
                        onClick={() =>
                            showModal(MODAL_TYPE.AVAILABLE_ADDONS, {
                                addons
                            })
                        }
                        className="a"
                    >
                        See All Available Add-Ons
                    </span>
                </div>
            </Grid>
            {exceedWarning && guestCount < addonCount && (
                <Grid
                    container
                    spacing={2}
                    style={{
                        color: theme.palette.warning.main
                    }}
                    alignItems="center"
                    className="mb-2"
                    wrap="nowrap"
                >
                    <Grid item>
                        <WarningIcon />
                    </Grid>
                    <Grid item>
                        <span>The number of clubs exceed the number of players. Are you sure?</span>{' '}
                        <Link
                            to="#"
                            onClick={event => {
                                event.preventDefault();
                                hideExceedWarning();
                            }}
                        >
                            Hide
                        </Link>
                    </Grid>
                </Grid>
            )}
            {addons
                .filter(e => e.quantity > 0)
                .map(oneAddon => {
                    return (
                        <Grid item key={oneAddon.id} xs={12}>
                            <NumericUpDown
                                label={`${oneAddon.name} - $${oneAddon.retail_price}`}
                                value={oneAddon.quantity}
                                onChange={(label, newValue) => {
                                    const newW = parseInt(newValue, 10);
                                    if (Number.isNaN(newW) || newW < 0) {
                                        return;
                                    }
                                    setAddonQuantity(oneAddon.id, newW);
                                }}
                            />
                        </Grid>
                    );
                })}
            <Grid item xs={12} sm={6}>
                <PriceRuleSelect
                    fullWidth
                    label="Add another"
                    options={addons.map(e => {
                        return {
                            ...e,
                            name: `${e.name} - ${formatMoney(e.retail_price)}`
                        };
                    })}
                    value={false}
                    setValue={newVal => {
                        // here the newVal is an id for an addon
                        const alreadyHad = addons.find(e => e.id === newVal);
                        setAddonQuantity(newVal, alreadyHad ? alreadyHad.quantity + 1 : 1);
                    }}
                />
            </Grid>
        </FormSection>
    );
}

export default withTheme(BookingConfigurationItem);
